import React from 'react';
import AuthShell from '../components/AuthShell';
import RegisterForm from '../components/RegisterForm';

export default function RegisterPage() {
  return (
    <AuthShell>
      <RegisterForm />
    </AuthShell>
  );
}
